import React from 'react';
import { GlassCard } from './GlassCard';

interface StatCardProps {
  value: string | number;
  label: string;
  icon?: React.ReactNode;
  suffix?: string;
  prefix?: string;
  variant?: 'default' | 'compact' | 'highlight';
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  icon,
  suffix,
  prefix,
  variant = 'default',
  className = '',
}) => {
  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        {icon && (
          <div className="w-10 h-10 rounded-lg bg-primary-light/10 dark:bg-primary-dark/10 flex items-center justify-center text-primary-light dark:text-primary-dark">
            {icon}
          </div>
        )}
        <div>
          <div className="text-2xl font-bold text-text-primary-light dark:text-text-primary-dark">
            {prefix}{value}{suffix}
          </div>
          <div className="text-xs text-text-secondary-light dark:text-text-secondary-dark">
            {label}
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'highlight') {
    return (
      <GlassCard
        variant="strong"
        className={`text-center border-2 border-primary-light/30 dark:border-primary-dark/30 ${className}`}
      >
        {icon && (
          <div className="mx-auto w-12 h-12 rounded-xl bg-gradient-to-br from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark flex items-center justify-center text-white mb-4">
            {icon}
          </div>
        )}
        <div className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark bg-clip-text text-transparent mb-2">
          {prefix}{value}{suffix}
        </div>
        <div className="text-text-secondary-light dark:text-text-secondary-dark">
          {label}
        </div>
      </GlassCard>
    );
  }

  // Default variant
  return (
    <GlassCard variant="medium" hover className={`text-center ${className}`}>
      {icon && (
        <div className="mx-auto w-12 h-12 rounded-xl bg-gradient-to-br from-primary-light/20 to-secondary-light/20 dark:from-primary-dark/20 dark:to-secondary-dark/20 flex items-center justify-center text-primary-light dark:text-primary-dark mb-4">
          {icon}
        </div>
      )}
      <div className="text-3xl md:text-4xl font-bold text-text-primary-light dark:text-text-primary-dark mb-1">
        {prefix}{value}{suffix}
      </div>
      <div className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
        {label}
      </div>
    </GlassCard>
  );
};

export default StatCard;
